import { PriceDisplay } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { DefaultOptionType } from "antd/es/select";
import { useMemo } from "react";
import upperFirst from "lodash/upperFirst";

export const useVenueFormPriceDisplayOptions = (): DefaultOptionType[] =>
  useMemo(
    () =>
      Object.keys(PriceDisplay).map((value) => ({
        value,
        label: upperFirst(value.replace("_", " ").toLowerCase()),
      })),
    []
  );
